import z from 'zod';
import {FirestoreTimestamp, firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {ExamModuleWrite, examModuleWriteSchema} from './examModuleWriteSchema';

/** Document shape as stored in DB (id from Firestore document id; createdAt set at write). */
export const examModuleDbSchema = examModuleWriteSchema.extend({
  createdAt: firestoreTimestampSchema,
});

export type ExamModuleDb = z.infer<typeof examModuleDbSchema>;

export function createExamModuleDb(write: ExamModuleWrite, createdAt: FirestoreTimestamp): ExamModuleDb {
  return {
    ...write,
    createdAt,
  };
}
